import AccountPage from "./AccountPage";

export default [
    {
        path: "/account",
        name: "account",
        component: AccountPage
    }
];